import { Inject, Injectable } from '@angular/core';
import { PriceEngineManager } from 'price-engine-core';
import { QuoteService } from '../models/quote/quote-service';
import { EPPClientPrototypeFromQuoteEngineMapper } from '../utils/EPPClientPrototypeFromQuoteEngineMapper';
import { PriceEnginePrototypeMapper } from '../utils/PriceEnginePrototypeMapper';
import { QuoteEnginePrototypeMapper } from '../utils/QuoteEnginePrototypeMapper';
import {
    QuoteService as PriceEngineQuoteService,
} from 'quote-domain-core';
@Injectable()
export class PriceEngineService {
    constructor(@Inject(PriceEngineManager) private readonly priceEngineManager: PriceEngineManager) {}

    getCorridors(
        quoteService: QuoteService,
        referential: any,
        referentialService: any,
        countryIsoCode: string,
        role: string,
        region: string,
    ): QuoteService {
        if (!role) {
            return quoteService;
        }
        const coreQS = QuoteEnginePrototypeMapper.setQuoteServicePrototype(quoteService);
        PriceEnginePrototypeMapper.setPricingItemPrototypes(coreQS);
        Object.setPrototypeOf(coreQS, PriceEngineQuoteService.prototype);
        this.priceEngineManager.getCorridors(coreQS as any, referential, referentialService, countryIsoCode, role, region);
        return EPPClientPrototypeFromQuoteEngineMapper.setQuoteServicePrototype(coreQS);
    }
}
